import script from "./EntityFieldSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityFieldSelector.vue?vue&type=script&setup=true&lang=js"

import "./EntityFieldSelector.vue?vue&type=style&index=0&id=a4412d26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4412d26"]])

export default __exports__